// Short blurbs shown under each station name.
// NOTE: "Emily's Garden" is based on publicly available info about
// Skidmore Dining. The rest are draft placeholders written from the
// station names alone — please review/edit these with your dining
// staff so they accurately describe what's actually served.
const stationDescriptions = {
  "Diner": 'Classic comfort-food favorites — the primary hot-food station.',
  "Emily's Garden": 'Vegetarian and vegan meals with ingredients from the campus community garden.',
  'Global/Noodle Bar': 'Rotating international dishes alongside a build-your-own noodle bar.',
  'Minus 9': 'Allergy-friendly meals prepared strictly free of the top nine allergens.',
  'The Corner Deli': 'Made-to-order sandwiches, wraps, and a rotating selection of sides.',
  "Supremo's": 'A dedicated pizza station equipped with a stone-hearth oven to cook fresh, hand-tossed pizzas.',
};

export default stationDescriptions;